import React from "react";
import { Card, CardContent, Grid, Typography, Box } from "@mui/material";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { absent, attendance, late, leave } from "../../iconsImports";

function EmployeeAvail({employeeData}) {
  // Sample counts for each category
  const attendanceCount = 10;
  const lateComingCount = 3;
  const absentCount = 2;
  const leaveAppliedCount = 5;
console.log("the employeeData ", employeeData)
  return (
    <Card sx={{ padding: 3, border: "2px solid #ccc", borderRadius: "8px" }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            marginBottom: 3,
            fontWeight: "bold",
            color: "#05004E",
            textAlign: "left",
          }}
        >
          Employees Availability
        </Typography>

        {/* Outer Box Container */}
        {/* Grid layout for four sections */}
        <Grid container spacing={2} sx={{ marginTop: 2 }}>
          {/* Attendance Section */}
          <Grid item xs={3}>
            <Card
              sx={{
                padding: 2,
                backgroundColor: "#FFE2E5",
                height: "100%",
                borderRadius: "14px",
              }}
            >
              <Grid container direction="column" alignItems="flex-start">
                <Grid item>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      backgroundColor: "#FA5A7D",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: 1,
                    }}
                  >
                    <img
                      src={attendance}
                      alt="attendance icon"
                      style={{ width: "25px", height: "25px" }}
                    />
                  </Box>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#151D48",
                      textAlign: "left",
                      fontSize: "28px",
                    }}
                  >
                    {employeeData?.attendance}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    variant="h6"
                    sx={{ color: "#425166", textAlign: "left" }}
                  >
                    Attendance
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Late Coming Section */}
          <Grid item xs={3}>
            <Card
              sx={{
                padding: 2,
                backgroundColor: "#FFF4DE",
                height: "100%",
                borderRadius: "14px",
              }}
            >
              <Grid container direction="column" alignItems="flex-start">
                <Grid item>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      backgroundColor: "#FF947A",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: 1,
                    }}
                  >
                    <img
                      src={late}
                      alt="attendance icon"
                      style={{ width: "25px", height: "25px" }}
                    />
                  </Box>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#151D48",
                      textAlign: "left",
                      fontSize: "28px",
                    }}
                  >
                    {employeeData?.late}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h6" sx={{ color: "#425166" }}>
                    Late Coming
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Absent Section */}
          <Grid item xs={3}>
            <Card
              sx={{
                padding: 2,
                backgroundColor: "#DCFCE7",
                height: "100%",
                borderRadius: "14px",
              }}
            >
              <Grid container direction="column" alignItems="flex-start">
                <Grid item>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      backgroundColor: "#3CD856",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: 1,
                    }}
                  >
                    <img
                      src={absent}
                      alt="attendance icon"
                      style={{ width: "25px", height: "25px" }}
                    />
                  </Box>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#151D48",
                      textAlign: "left",
                      fontSize: "28px",
                    }}
                  >
                    {employeeData?.absent}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h6" sx={{ color: "#425166" }}>
                    Absent
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Leave Applied Section */}
          <Grid item xs={3}>
            <Card
              sx={{
                padding: 2,
                backgroundColor: "#F3E8FF",
                height: "100%",
                borderRadius: "14px",
              }}
            >
              <Grid container direction="column" alignItems="flex-start">
                <Grid item>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      backgroundColor: "#BF83FF",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: 1,
                    }}
                  >
                    <img
                      src={leave}
                      alt="attendance icon"
                      style={{ width: "25px", height: "25px" }}
                    />
                  </Box>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#151D48",
                      textAlign: "left",
                      fontSize: "28px",
                    }}
                  >
                    {employeeData?.leave_applied}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography sx={{ fontSize: "16px", color: "#425166" }}>
                    Leave Applied
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default EmployeeAvail;
